import '../styles/variables.scss';

const InputGroup = ({ label, type = "text", name, value, onChange, options, placeholder, error, required, max }) => {
  const inputStyle = {
    width: '100%',
    padding: '0.75rem 1rem',
    borderRadius: '0.75rem',
    border: `1px solid ${error ? '#ef4444' : '#e2e8f0'}`,
    backgroundColor: '#ffffff',
    fontSize: '1rem',
    color: '#1e293b',
    outline: 'none',
    transition: 'all 0.2s ease',
    appearance: type === 'select' ? 'none' : 'auto',
    backgroundImage: type === 'select' ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'%3F%3E%3C/svg%3E")` : 'none',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 1rem center',
    backgroundSize: '1rem'
  };

  return (
    <div className="input-group" style={{ marginBottom: '1rem', position: 'relative' }}>
      <label
        style={{
          display: 'block',
          color: 'var(--color-text-secondary)',
          fontWeight: 500,
          fontSize: '0.95rem'
        }}
      >
        {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
      </label>

      {type === 'select' ? (
        <select
          name={name}
          value={value}
          onChange={onChange}
          className="form-input"
          style={{ ...inputStyle, cursor: 'pointer' }}
        >
          <option value="" disabled>{placeholder || 'Select an option'}</option>
          {options && options.map((opt) => {
            const isObj = typeof opt === 'object' && opt !== null;
            const optValue = isObj && opt.value !== undefined ? opt.value : opt;
            const optLabel = isObj && opt.label !== undefined ? opt.label : opt;
            return (
              <option key={optValue} value={optValue}>
                {optLabel}
              </option>
            );
          })}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          max={max}
          className="form-input"
          style={inputStyle}
        />
      )}

      {error && (
        <span
          className="error-msg"
          style={{
            color: '#ef4444',
            fontSize: '0.85rem',
            marginTop: '0.25rem',
            display: 'block',
            animation: 'fadeIn 0.3s ease'
          }}
        >
          {error}
        </span>
      )}
      <style>{`
        .form-input:focus {
          border-color: #4f46e5 !important;
          box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.2);
          transform: scale(1.01);
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default InputGroup;
